export default __webpack_public_path__ + "static/media/trash_disabled.755baa16.svg";